/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Before/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Before({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Wait/Content/Type/Content/Before"
  
}) {
let eventActionDataTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.type',
})
let constantData = 'before'
let aggregateData = fromAggregate.equals(eventActionDataTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 isDisabled={true}
 data="event_action.data.type"
 data="'before'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="Before appointment date"
/>
{children}
</React.Fragment>)
}